export default __webpack_public_path__ + "static/media/soin-beige-logo.697288bf.png";